(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/dialogs/after-payment-dialog.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/dialogs/after-payment-dialog.js');

'use strict';

function afterPaymentDialog(_ref) {
  let next = _ref.next,
    price = _ref.price,
    numberOfTickets = _ref.numberOfTickets,
    _ref$accountBalance = _ref.accountBalance,
    accountBalance = _ref$accountBalance === void 0 ? 0 : _ref$accountBalance;
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'games',
    title: numberOfTickets > 1 ? "Dina lotter f\xF6r ".concat(price, " kr \xE4r betalda") : "Din lott f\xF6r ".concat(price, " kr \xE4r betald"),
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: 'Insättningen och betalningen lyckades!'
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: "Ditt saldo: ".concat(accountBalance, " kr")
    }],
    actions: [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  }));
}
setGlobal('svs.ticketsOrderHome.components.afterPaymentDialog', afterPaymentDialog);

 })(window);